/* eslint-disable arrow-parens */
import Immutable from 'seamless-immutable';
import _ from 'lodash';
import moment from 'moment';
import {
  SAVE_WEARABLES,
  APPEND_WEARABLES,
  SAVE_WEARABLES_PAGINATION,
  SET_SELECTED_WEARABLE,
  SET_WEARABLES_FILTER,
  RESET_WEARABLES_FILTERS,
  RESET_WEARABLES_DATA,
  UPDATE_WEARABLE,
  REMOVE_WEARABLE,
  SAVE_WEARABLE_HISTORY,
  APPEND_WEARABLE_HISTORY,
  SAVE_WEARABLE_HISTORY_PAGINATION,
  SET_WEARABLE_HISTORY_FILTER,
  RESET_WEARABLE_HISTORY_FILTER,
  RESET_WEARABLE_HISTORY_DATA,
  SET_WEARABLE_ORDER,
  SET_WEARABLE_OPERATIONAL_MODE,
  SAVE_WEARABLE_ALARMS,
  APPEND_WEARABLE_ALARMS,
  SAVE_WEARABLE_ALARMS_PAGINATION,
  SET_WEARABLE_ALARMS_FILTER,
  RESET_WEARABLE_ALARMS_FILTER,
  RESET_WEARABLE_ALARMS_DATA,
  UPDATE_WEARABLE_ALARM_IN_STATE,
  SAVE_ACTIVE_ALARMS,
} from '../actions/actionTypes/wearable';

const initialState = Immutable({
  data: {
    content: [],
    pagination: {},
    filters: {},
    sorting: {
      orderBy: undefined,
      orderDir: 'DESC',
    },
  },
  history: {
    content: [],
    pagination: {},
    filters: {
      fromDate: moment().subtract(1, 'M').startOf('day').valueOf(),
      toDate: moment().add(1, 'd').endOf('day').valueOf(),
    },
  },
  alarms: {
    content: [],
    pagination: {},
    filters: {
      fromDate: moment().subtract(1, 'M').startOf('day').valueOf(),
      toDate: moment().add(1, 'd').endOf('day').valueOf(),
    },
  },
  activeAlarms: [],
  selectedWearable: {},
  isOperationalMode: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case SAVE_WEARABLES:
      return state.setIn(['data', 'content'], action.wearables);
    case APPEND_WEARABLES:
      return state.setIn(['data', 'content'], [...state.data.content, ...action.wearables]);
    case UPDATE_WEARABLE: {
      const index = _.findIndex(state.data.content, data => data.id === action.wearable.id);
      if (index !== -1) {
        return state.setIn(['data', 'content', index], action.wearable);
      }
      return state.setIn(['data', 'content'], [...state.data.content, action.wearable]);
    }
    case REMOVE_WEARABLE: {
      const wearables = _.filter(state.data.content, wearableState => wearableState.id !== action.wearableId);
      return state.setIn(['data', 'content'], wearables);
    }
    case SAVE_WEARABLE_HISTORY: {
      return state.setIn(['history', 'content'], action.history);
    }
    case APPEND_WEARABLE_HISTORY: {
      return state.setIn(['history', 'content'], [...state.history.content, ...action.history]);
    }
    case SAVE_WEARABLE_HISTORY_PAGINATION: {
      return state.setIn(['history', 'pagination'], action.pagination);
    }
    case SET_WEARABLE_HISTORY_FILTER: {
      return state.setIn(['history', 'filters', action.field], action.value);
    }
    case RESET_WEARABLE_HISTORY_FILTER: {
      return state.setIn(['history', 'filters'], {
        fromDate: moment().subtract(1, 'M').startOf('day').valueOf(),
        toDate: moment().add(1, 'd').endOf('day').valueOf(),
      });
    }
    case RESET_WEARABLE_HISTORY_DATA: {
      return state.setIn(['history', 'content'], []).setIn(['history', 'pagination'], {});
    }
    case SAVE_WEARABLE_ALARMS: {
      return state.setIn(['alarms', 'content'], action.alarms);
    }
    case APPEND_WEARABLE_ALARMS: {
      return state.setIn(['alarms', 'content'], [...state.alarms.content, ...action.alarms]);
    }
    case SAVE_WEARABLE_ALARMS_PAGINATION: {
      return state.setIn(['alarms', 'pagination'], action.pagination);
    }
    case SET_WEARABLE_ALARMS_FILTER: {
      return state.setIn(['alarms', 'filters', action.field], action.value);
    }
    case RESET_WEARABLE_ALARMS_FILTER: {
      return state.setIn(['alarms', 'filters'], {
        fromDate: moment().subtract(1, 'M').startOf('day').valueOf(),
        toDate: moment().add(1, 'd').endOf('day').valueOf(),
      });
    }
    case RESET_WEARABLE_ALARMS_DATA: {
      return state.setIn(['alarms', 'content'], []).setIn(['alarms', 'pagination'], {});
    }
    case UPDATE_WEARABLE_ALARM_IN_STATE: {
      const index = _.findIndex(state.alarms.content, data => data.id === action.alarm.id);
      if (index !== -1) {
        return state.setIn(['alarms', 'content', index], action.alarm);
      }
      return state.setIn(['alarms', 'content'], [...state.alarms.content, action.alarm]);
    }
    case SAVE_ACTIVE_ALARMS: {
      return state.set('activeAlarms', action.activeAlarms);
    }
    case SAVE_WEARABLES_PAGINATION:
      return state.setIn(['data', 'pagination'], action.pagination);
    case SET_SELECTED_WEARABLE:
      return state.set('selectedWearable', action.wearable);
    case SET_WEARABLES_FILTER:
      return state.setIn(['data', 'filters', action.field], action.value);
    case RESET_WEARABLES_DATA:
      return state.setIn(['data', 'content'], []).setIn(['data', 'pagination'], {});
    case RESET_WEARABLES_FILTERS:
      return state.setIn(['data', 'filters'], {});
    case SET_WEARABLE_ORDER:
      return state
        .setIn(['data', 'sorting', 'orderBy'], action.orderBy)
        .setIn(['data', 'sorting', 'orderDir'], action.orderDir);
    case SET_WEARABLE_OPERATIONAL_MODE:
      return state.set('isOperationalMode', action.isOperationalMode);
    default:
      return state;
  }
}
